import React from "react";
import AccountingPlaceholder from "./AccountingPlaceholder";

const PurchaseDocument: React.FC = () => (
  <AccountingPlaceholder title="Chứng từ mua hàng" />
);

export default PurchaseDocument;
